// extracted by mini-css-extract-plugin
export default {"wrapper":"Agree_wrapper__5zlnS","rounded_checkbox":"Agree_rounded_checkbox__aZsZ2"};